import { computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { useEmailInbox } from 'dashboard/composables/useEmailInbox';
import { useInboxUnreadCounts } from 'dashboard/composables/useInboxUnreadCounts';

export const useInboxSidebarBadge = enabled => {
  const { t } = useI18n();
  const route = useRoute();
  const { unreadCount: emailUnreadCount, fetchUnreadCount } = useEmailInbox();
  const {
    notificationsUnreadCount,
    requestsUnreadCount,
    remindersUnreadCount,
    refreshUnreadCounts,
    startUnreadCountSync,
  } = useInboxUnreadCounts();

  const totalUnreadCount = computed(
    () => notificationsUnreadCount.value + emailUnreadCount.value
  );
  const tooltipTitle = computed(() =>
    t('INBOX.BADGES.SIDEBAR_TITLE', { count: totalUnreadCount.value })
  );
  const ariaLabel = computed(() =>
    t('INBOX.BADGES.SIDEBAR_ARIA_LABEL', { count: totalUnreadCount.value })
  );
  const tooltipLines = computed(() => [
    { label: t('INBOX.CENTER.NAV.REQUESTS'), count: requestsUnreadCount.value },
    {
      label: t('INBOX.CENTER.NAV.REMINDERS'),
      count: remindersUnreadCount.value,
    },
    { label: t('INBOX.TABS.EMAILS'), count: emailUnreadCount.value },
  ]);

  const fetchCounts = () => {
    startUnreadCountSync();
    fetchUnreadCount();
  };

  if (enabled) {
    watch(
      () => route.params.accountId,
      (accountId, previousAccountId) => {
        if (accountId && accountId !== previousAccountId) {
          refreshUnreadCounts();
          fetchUnreadCount();
        }
      }
    );
  }

  return {
    totalUnreadCount,
    tooltipTitle,
    tooltipLines,
    ariaLabel,
    fetchCounts,
  };
};
